import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  year: number = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/footer/footer.component.ts